var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import queryString from 'query-string';
export const timeoutPromise = (delay) => {
    return new Promise(_resolve => {
        const ids = setTimeout(() => {
            clearTimeout(ids);
            _resolve({ type: 'timeout' });
        }, delay);
    });
};
const formatResponse = (response) => {
    try {
        return JSON.parse(response);
    }
    catch (e) {
        return response;
    }
};
const formatError = (res, status) => {
    if (typeof res === 'string')
        return {
            message: res,
            status,
        };
    return Object.assign(Object.assign({}, res), { status });
};
const defaultHeaders = {
    Accept: 'text/plain;v=1.0',
    'Content-Type': 'application/json',
};
export const fetchFormat = (config, signal) => __awaiter(void 0, void 0, void 0, function* () {
    let { url: uri, method = 'GET', headers, query, body, params } = config;
    // TODO: adjust no url
    if (!uri)
        throw new Error('no url');
    if (!body && params) {
        body = JSON.stringify(params);
    }
    if (method === 'GET' || method === 'DELETE') {
        const _query = query || params;
        if (_query) {
            uri = Object.keys(_query).length > 0 ? `${uri}?${queryString.stringify(_query)}` : uri;
        }
        body = undefined;
    }
    // TODO:fix headers
    const myHeaders = Object.assign(Object.assign({}, defaultHeaders), headers);
    const result = yield fetch(uri, {
        method,
        headers: myHeaders,
        body,
        signal,
    });
    const text = yield result.text();
    const res = formatResponse(text);
    if (result.status.toString()[0] !== '2' || !result.ok) {
        throw formatError(res ? res : result.statusText, result.status);
    }
    return res;
});
